import React from 'react';
import styled from 'styled-components';
import { H4 } from '../styled';
import quotemarkUrl from '../../images/quotemark.svg';

const QuoteWrapper = styled.div`
  position: relative;
  background: #F8F8FB;
  padding: 25px 32px;
  border-radius: 2px;
`;

const QuoteImg = styled.img`
  position: absolute;
  top: -10px;
`;

function Quote({ input }) {
  const { primary } = input;


  return (
    <QuoteWrapper>
      <QuoteImg src={quotemarkUrl} />
      <H4>{primary.quote_text}</H4>
    </QuoteWrapper>
  );
}

export { Quote };
